import { useState } from 'react'
import { Link } from 'react-router-dom'

const KEY = 'lc_legal_notice_2026-10-08'
export function LegalNotice() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY) === 'seen' } catch { return false }
  })
  if (hidden) return null
  return <aside className="flex shrink-0 items-start gap-3 border-b border-divider bg-surface px-4 py-3 text-sm" aria-label="Изменения документов">
    <p className="flex-1">Обновлены условия и документы о данных от 08.10.2026. Оплаченные права сохраняются. <Link to="/legal/terms" className="text-primary underline">Прочитать изменения</Link></p>
    <button type="button" aria-label="Закрыть уведомление" onClick={() => {
      setHidden(true)
      try { localStorage.setItem(KEY, 'seen') } catch { /* optional local preference */ }
    }} className="px-2 py-1 text-muted">Понятно</button>
  </aside>
}
